<template>
  <div class="toolbar column">
    <div class="columns">
        <div class="column is-2">
          <mf-multi-select v-if="actions?.length"
            :disabled="false"
            v-model="selectedAction"
            track-by="event"
            label="name"
            :placeholder="'Bulk Actions'"
            :multiple="false"
            :options="actions"
            :allow-empty="false"
            @select="triggerAction($event)"
            :noDirtyEmit='true'
          ></mf-multi-select>
        </div>
        <div class="column" v-if="!$_.isEmpty(licenseUsage)" :class="!$_.isEmpty(licenseUsage) ? 'licenses-height' : ''">
            <p class="has-text-black-bis is-flex is-align-items-center is-size-5 has-text-weight-semibold">
              Seat Licenses Reserved: {{ licenseUsage.seatsReserved }} of {{ licenseUsage.seatsTotal }}
            </p>
            <p class="has-text-black-bis is-flex is-align-items-center is-size-5 has-text-weight-semibold">
              License Assignments Consumed: {{ licenseUsage.seatReservationsConsumed }} of {{
                licenseUsage.seatReservationCount }}
            </p>
        </div>
      <div class="column is-offset-5 is-offset-2-desktop is-flex is-align-items-center is-justify-content-flex-end">
        <slot name="filterToggle"></slot>
        <div v-if="$slots.filterToggle" class="is-divider-vertical"></div>
        <div v-for="(button, idx) in buttons" :key="idx" class="toolbar-icon">
          <div class="py-0 is-flex" :class="['icon-activityhistory', 'icon-clone'].includes(button.icon) ? 'is-align-items-center is-flex-direction-row' : 'mr-0' ">
            <div class="is-divider-vertical" v-if="button.icon === 'icon-clone'"></div>
            <button @click="triggerAction(button.event)" v-tooltip="button.tooltip" class="button p-0"
              v-if="!isDisabledOnPermission(button)">
              <i :class="button.icon"></i>
            </button>
            <div class="is-divider-vertical" v-if="button.icon === 'icon-activityhistory' && buttons.length > 1"></div>
            <!-- need to add for buttons:disabled="disabledOnPermission(button)" -->
          </div>
        </div>
        <div class="is-divider-vertical" v-if="buttons.length"></div>
        <div class="is-flex is-align-items-center is-justify-content-flex-end">
          <search-bar :placeholder="searchPlaceHolder" @search="triggerAction({type: 'search', data: $event})" :shouldEmit="true">
          </search-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar.vue';
import MfMultiSelect from '@/components/abstract/MfMultiSelect.vue';
import { onMounted, reactive, toRefs } from 'vue';
import { computed } from 'vue';
import { isFunction } from 'lodash';
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default {
  name: 'TableToolbar',
  components: {
    SearchBar,
    MfMultiSelect,
  },
  props: {
    searchPlaceHolder: String,
    toolbarOpts: {
      type: Object,
      default: () => { }
    }
  },
  setup(props, { emit }) {
    const data = reactive({
      licenseUsage: {},
      selectedAction: null,
    });

    const { getPermissionValues } = PermissionMixin();

    const actions = computed(() => {
      if (isFunction(props.toolbarOpts.bulkActions)) {
        const actionList = props.toolbarOpts.bulkActions();
        return actionList?.filter((act) => {
          return !(getPermissionValues({
            permissionModule: act.permissionModule,
            type: act.alterDataKey,
          }))
        })
      }
      return props.toolbarOpts.bulkActions || [];
    });

    const buttons = computed(() => {
      const allowedActions = _.filter(props.toolbarOpts?.buttons, (btn) => {
        return !isDisabledOnPermission(btn)
      })
      return allowedActions || []
    })

    const triggerAction = (action) => {
      emit('handleAction', action)
    };

    onMounted(async () => {
      // data.licenseUsage = await Users.getLicensesUsage();
    });

    const isDisabledOnPermission = (opt) => getPermissionValues({
      permissionModule: opt.permissionModule,
      type: opt.alterDataKey,
    });

    return {
      ...toRefs(data),
      buttons,
      triggerAction,
      actions,
      isDisabledOnPermission,
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.searchbar .input) {
  padding-left: 5px !important;
}
</style>